import { createContext, useContext, useState, ReactNode } from "react";

type DocumentData = {id: string;
  title: string;
  formData: any;
  metaDescription: string;
  notificationRecipient: string;
}; // adatta alle tue esigenze

type ModalContextType = {
  isOpen: boolean;
  openModal: (data: DocumentData) => void;
  closeModal: () => void;
  documentData: DocumentData | null;
};

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [documentData, setDocumentData] = useState<DocumentData | null>(null);

  const openModal = (data: DocumentData) => {
    setDocumentData(data);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setDocumentData(null);
  };

  return (
    <ModalContext.Provider value={{ isOpen, openModal, closeModal, documentData }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) throw new Error("useModal must be used within a ModalProvider");
  return context;
};
